<template>
  <div>
    <p class="text-small">{{ item.name }}<br><span class="text-super-small">{{ item.license_plate }} {{ item.getprovince ? item.getprovince.name : '' }}{{ item.province_plate ? item.province_plate.name : '' }}</span></p>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
  }
}
</script>
<style scoped>
.text-small {
  font-size: 1rem;
  padding: 0 0;
  margin: 0 0;
  line-height: 16px;
}
.text-super-small {
  font-size: 0.6rem;
}
</style>
